const totalCartPriceBeforeTax = (products, combos) => {
  let totalPrice = 0;
  products.forEach(product => (totalPrice += product.totalPrice));
  combos.forEach(combo => totalPrice += combo.totalPrice)
  return totalPrice;
};

export default totalCartPriceBeforeTax;
